import { useAutoScroll, useIsLoading } from '@/atoms'
import { LayoutComposer, ListFooter, NoEntries, NoResults } from '@/components/List'
import { ListLoading } from '@/components/ListLoading'
import { StructuredVirtualList } from '@/components/StructuredVirtualList'
import { ComponentSize, FormColumn } from '@/components/layout'

import { Item } from './Item'

import { Header } from './Header'
import { useDataForList } from './hooks/useDataForList'
import { useListHandlers } from './hooks/useListHandlers'
import { useTexts } from './hooks/useTexts'
import { useVehicles } from './hooks/useVehicles'

import { Box } from '@mui/material'

const getItemHeight = () => 79
const getItemId = (item: uui.domain.client.UnifiedVehicle) => item.unifiedId

export function TrackingList() {
  const { handleOnSelect, handleOnSelectAll } = useListHandlers()
  const { structure, lastSelectedVehicle, selection } = useDataForList()
  const texts = useTexts()
  const vehicles = useVehicles()

  const isLoading = useIsLoading('fetchGpsData')

  useAutoScroll('tracking', lastSelectedVehicle)

  const allSelected = selection.length >= structure.shownItems
  const multiSelect = selection.length > 1

  return (
    <>
      <FormColumn width={320} testid="form__column-primary">
        <Header />

        <Box width="100%" height="100%" flex="0 1 auto" position="relative">
          <LayoutComposer
            totalItems={structure.totalItems}
            shownItems={structure.shownItems}
            noResults={
              <NoResults title={texts.noResults.title} description={texts.noResults.description} />
            }
            noEntries={
              <NoEntries title={texts.noEntries.title} description={texts.noEntries.description} />
            }
            list={
              <ComponentSize
                render={size => {
                  // TODO: reset the scroll when the list options change
                  return isLoading ? (
                    <ListLoading />
                  ) : (
                    <StructuredVirtualList
                      itemsById={vehicles}
                      structure={structure}
                      listApiCategory="tracking"
                      getItemHeights={getItemHeight}
                      RenderItem={Item}
                      listHeight={size.height}
                      getItemId={getItemId}
                      selectedItemIds={selection}
                      onSelect={handleOnSelect}
                      buffer={50}
                    />
                  )
                }}
              />
            }
          />
        </Box>

        {multiSelect && (
          <ListFooter
            label={texts.selectBtn(allSelected)}
            onToggleSelection={handleOnSelectAll}
            checked={allSelected}
          />
        )}
      </FormColumn>
    </>
  )
}
